<template>
  <div class="home">
    <Header />
    <b-row class="pt-5">
      <b-col cols="12" md="8" lg="4" offset-md="2" offset-lg="4">
        <b-card>
          <h2 class="text-center">{{ $t('course_booking_system') }}</h2>
          <hr>

          <!-- <b-button variant="success" @click="$router.push('/new-member')" class="py-3 mt-4" block>New Member</b-button> -->
          <b-button variant="success" @click="$router.push('/member-login')" class="py-3 mt-5" block>{{ $t('individual_member') }}</b-button>
          <b-button variant="success" @click="$router.push('/corporate-login')" class="py-3" block>{{ $t('corporate_member') }}</b-button>
        </b-card>
      </b-col>
    </b-row>
    <div class="download-guideline">
      <span class="text-green link" @click="downloadGuideline">{{$t('registration_guide')}}</span>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'Home',
  components: {
    Header
  },
  created() {
    this.redirectUser();
  },
  methods: {
    downloadGuideline() {
      window.open("/guideline_students.pdf")
    }
  }
}
</script>

<style scoped>
.download-guideline {
    position: absolute;
    bottom: 20px;
    right: 20px;
}
</style>
